/**
 * Testing Configuration Objects
 * Contains all testing sheet configurations for different types
 */

// MAZAR testing configuration
// Used by: MAZAR, Template M, Template B1, Template B2
// These templates use tab-based sheets with fields for test procedures,
// observations, results, additional procedures, and operating effectiveness.
export const testingTabObject = {
  'Test Results': ['Test Procedure', 'Test Performed', 'Observation', 'Result'],
  'Additional Procedures / Mitigating Factors': [
    'Additional Test Procedure',
    'Additional Test Performed',
    'Additional Observation',
    'Additional Conclusion'
  ],
  'Operating Effectiveness Table': [
    'CR Level',
    'TOC Assurance Level',
    'Period the Control is Operating ?',
    'Estimated Population and Source',
    'Sample Size',
    'Sampling Methodology',
    'Relevant IPE',
    'OE Conclusion',
    'Control Tested by Internal Audit',
    'Internal Audit conclusion on operating effectiveness',
    "Period covered by Internal Audit's tests",
    'Planned use of Internal Audit testing',
    'Reference'
  ],
  'Overall Conclusion': [
    'Test Procedure',
    'Test Performed',
    'Observation',
    'Result'
  ]
};

// BDO Audit testing configuration
export const auditTestingTabObject = {
  'Test Results': [
    'Test Procedure',
    'Test Performed',
    'Observation',
    'Result',
    'Sheet reference'
  ],
  'Overall Conclusion': [
    'Test Procedure',
    'Test Performed',
    'Observation',
    'Result'
  ]
};

// SOC2 testing configuration
export const SOC2testingTabObject = {
  'Design Effectiveness': [
    'Test Procedures',
    'WP Reference',
    'Design & Compliance Testing',
    'Design  Effectiveness'
  ],
  'Operating Table': [
    'Test Procedures',
    'Control No.',
    'Operational Effectiveness Testing',
    'Operating Effectiveness'
  ],
  'Overall Conclusion': [
    'Test Procedures',
    'Control Activity',
    'Overall Conclusion (Effective / Ineffective)'
  ]
};

// Style configurations
export const tabStyle = {
  outline: 'none',
  overflow: 'auto',
  whiteSpace: 'nowrap'
};

export const tableBoxStyle = {
  display: 'flex',
  flexDirection: 'Column',
  justifyContent: 'center',
  marginBottom: '30px',
  border: '2px solid black',
  borderRadius: '3px'
};

export const tableHeaderStyle = {
  textAlign: 'center',
  backgroundColor: 'orange',
  color: 'white',
  fontSize: '20px',
  fontWeight: 'bold',
  borderTopLeftRadius: '3px',
  borderTopRightRadius: '3px',
  borderBottom: '2px solid black'
};
